window.geo = new function(){
  this.getLocation = function(callback) {
    var timeoutId = setTimeout(function() {
      console.warn("Geolocation fetch timed out. Executing callback with null.");
      if (typeof callback === 'function') callback(null);
      callback = function() {}; // prevent double execution
    }, 15000);

    var wrappedCallback = function(loc) {
      clearTimeout(timeoutId);
      if (typeof callback === 'function') {
        callback(loc);
        callback = function() {}; 
      }
    };

    if (typeof window !== 'undefined' && window.cordova && typeof cordova.plugins !== 'undefined' && cordova.plugins.diagnostic) {
      cordova.plugins.diagnostic.getPermissionsAuthorizationStatus(function(statuses) {
        var handled = false;
        for (var permission in statuses) {
          if (handled) break;
          switch (statuses[permission]) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              handled = true;
              requestLocationAccuracy(wrappedCallback);
              break;
            case cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
              handled = true;
              requestLocationAuthorization(wrappedCallback);
              break;
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              handled = true;
              wrappedCallback(null);
              break;
          }
        }
      }, function(error) {
        console.error("Diagnostic error: " + error);
        wrappedCallback(null);
      }, [
        cordova.plugins.diagnostic.permission.ACCESS_FINE_LOCATION,
        cordova.plugins.diagnostic.permission.ACCESS_COARSE_LOCATION
      ]);
    } else {
      // Browser or environment without cordova diagnostic
      fetchLocation(wrappedCallback);
    }
  };

  function requestLocationAuthorization(callback) {
    cordova.plugins.diagnostic.getPermissionAuthorizationStatus(function(status) {
      if (status === cordova.plugins.diagnostic.permissionStatus.GRANTED) {
        requestLocationAccuracy(callback);
      } else {
        cordova.plugins.diagnostic.requestLocationAuthorization(function(newStatus) {
          if (newStatus === cordova.plugins.diagnostic.permissionStatus.GRANTED) {
            requestLocationAccuracy(callback);
          } else {
            callback(null);
          }
        }, function(error) {
          callback(null);
        });
      }
    }, function(error) {
      callback(null);
    }, cordova.plugins.diagnostic.permission.ACCESS_FINE_LOCATION);
  }
  
  function requestLocationAccuracy(callback) {
    if (cordova.plugins.locationAccuracy) {
      cordova.plugins.locationAccuracy.canRequest(function(canRequest) {
        if (canRequest) {
          cordova.plugins.locationAccuracy.request(function() {
            fetchLocation(callback);
          }, function(error) {
            fetchLocation(callback); // try fetching anyway
          }, cordova.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
        } else {
          fetchLocation(callback);
        }
      });
    } else {
      fetchLocation(callback);
    }
  }

  function fetchLocation(callback) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        callback(location);
      }, function(error) {
        console.warn('Geolocation error: ' + error.message);
        callback(null);
      }, {
        maximumAge: 3000,
        timeout: 10000,
        enableHighAccuracy: true
      });
    } else {
      callback(null);
    }
  }
};
